import React from "react";

const TablaQuirofano = ({item, passDataQuirofano}) => {
  const quirofano = {
    codigoQuirofano:item.ConsCod,
    descripcionQuirofano: item.ConsDet,
    sedeQuirofano:item.MCDpto
  }
    const handleQuirofano =() =>{
        //console.log(item, "quirofnano")
        passDataQuirofano(quirofano)
    }
  return (
    <tr key={item.ConsCod} className="border-b" >
      <td className="text-xs text-gray-900 font-medium px-6 py-2 whitespace-pre-wrap">
        <button
          onClick={handleQuirofano}
          type="button"
          className="inline-block px-3 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
        >
          Seleccionar
        </button>
      </td>
      <td className="text-xs text-gray-900 font-medium px-6 py-2 whitespace-pre-wrap">
        {item.ConsCod}
      </td>
      <td className="text-xs text-gray-900 font-medium px-6 py-2 whitespace-pre-wrap">
        {item.ConsDet}
      </td>
    </tr>
  );
};

export default TablaQuirofano;
